import {Pipe, PipeTransform} from '@angular/core';
import {ProfileService} from '../../services/profile.service';
import {FaqCategory} from '../../model/FaqCategory';

@Pipe({
  name: 'filtercategorywithperm',
  standalone: true,
})
export class FilterCategoryWithPermPipe implements PipeTransform {

  constructor(private profileService: ProfileService) {
  }

  transform(cats: FaqCategory[], adminMode: boolean): Promise<FaqCategory[]> {
    return new Promise<FaqCategory[]>(resolve => {
      this.profileService.getProfile().subscribe(p => {
        if (adminMode) {
          resolve(cats);
        } else {
          resolve(cats
            .filter(c => c.slug !== 'public')
            .filter(c => p.me ? p.me.contracts.some(contract => contract.product.tag.toLowerCase() === c.slug.toLowerCase()) : true
            ));
        }
      });
    });
  }
}
